import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=26a8e3cb&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=26a8e3cb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a8e3cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a8e3cb')) {
      api.createRecord('26a8e3cb', component.options)
    } else {
      api.reload('26a8e3cb', component.options)
    }
    module.hot.accept("./VerificationCode.vue?vue&type=template&id=26a8e3cb&scoped=true", function () {
      api.rerender('26a8e3cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/VerificationCode.vue"
export default component.exports